import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { isIOS, nativeAppleSignIn, isSignInCanceled } from '../lib/socialAuth';

// Sign in with Apple — rendered ONLY on native iOS (Apple Guideline 4.8).
// Uses Apple's official logo artwork and follows the Sign in with Apple HIG
// (black button, white official Apple logo, system text). Do not modify the logo.
export default function AppleSignInButton({ label = 'Sign in with Apple', testId = 'apple-signin-button' }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (!isIOS()) return null;

  const handleClick = async () => {
    setLoading(true);
    try {
      await nativeAppleSignIn();
      toast.success('Welcome!');
      navigate('/home', { replace: true });
    } catch (err) {
      if (!isSignInCanceled(err)) {
        const msg = err?.response?.data?.detail || err?.message || 'Apple sign-in failed. Please try again.';
        toast.error(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      data-testid={testId}
      aria-label={label}
      style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, sans-serif' }}
      className="w-full h-12 rounded-lg font-medium text-[17px] leading-none flex items-center justify-center gap-2 bg-black text-white transition-opacity active:opacity-80 disabled:opacity-60"
    >
      {loading ? (
        <div className="w-5 h-5 border-2 border-white/40 border-t-white rounded-full animate-spin" />
      ) : (
        <svg width="15" height="18" viewBox="0 0 814 1000" fill="currentColor" aria-hidden="true" focusable="false" style={{ display: 'block' }}>
          <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76.5 0-103.7 40.8-165.9 40.8s-105.6-57-155.5-127C46.7 790.7 0 663 0 541.8c0-194.4 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z" />
        </svg>
      )}
      {loading ? 'Signing in…' : label}
    </button>
  );
}
